export const ShouldForceV2RoutesCookieKey = "shouldForceV2Routes";
